const e = {
  name: "NewYork",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.3,0H13v5c0,1.1,0.9,2,2,2h1v2c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5V8.9c0-0.8,0.2-1.5,0.4-2.2l0,0L9.3,0z
			 M10.7,2L8.3,7.5C8.1,8,8,8.5,8,8.9V9c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3V8.9c-1.7-0.4-3-2-3-3.9V2H10.7z"/>
		<path class="st0" d="M11,14H6v2h2v5h2.4l1.5,3h2.2l-1.5-3H14v-1.8l2.4,4.8h2.2l-4-8H16v-2H11z M12,16v3h-2v-3H12z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as NewYork
};
